import { IntlShape } from 'react-intl';
import { formatTranslation } from 'intl';
import { UserTranslationKeys } from 'intl/keys';
import { UserRole } from 'shared/types/userRole';
import { UserCreateOnView } from 'shared/domain/user/types/view';

export function createEmptyUser(intl: IntlShape): UserCreateOnView {
  return {
    email: '',
    role: {
      label: formatTranslation(intl, UserTranslationKeys.standard),
      _id: UserRole.standard,
    },
    processes: [],
    sites: [],
  };
}
